import React from 'react';

const BeakerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 3.104v1.244c0 .892-.567 1.686-1.398 2.04a11.054 11.054 0 0 0-3.702 2.332C3.829 9.534 3.392 10.356 3.392 11.25V18a2.25 2.25 0 0 0 2.25 2.25h12.75A2.25 2.25 0 0 0 20.608 18v-6.75c0-.894-.437-1.716-1.258-2.532a11.05 11.05 0 0 0-3.702-2.332c-.83-.354-1.398-1.148-1.398-2.04V3.104M9.75 3.104c0-.498.42-1.104.97-1.104h2.56c.55 0 .97.606.97 1.104m-4.5 0h4.5m-4.5 6h4.5m-4.5 3h4.5m-6.75 3h9" />
  </svg>
);

export default BeakerIcon;